import React from "react";
import "./Pages.css";
import chat from "../../assets/chat.png";
import announcement from "../../assets/announcement.png"

const Anzeige = () => {
  return (
    <div className="anzeige">
      {/* */}
      <img width={300} src={announcement} alt="Anzeige" /><pre/>
      <p style={{color:"red"}}>
      <strong></strong><pre/>
      Liebe Patienten,<pre/>
      an folgende Tagen ist die Praxis nur für Terminvergabe und Rezeptausstellung besetzt:<pre/>
      Donnerstag, den 17.09.2026 - 08:00 Uhr bis 12:00 Uhr <pre/>
      Freitag, den 18.09.2026 - 08:00 Uhr bis 12:00 Uhr
      <pre/>
      In Fällen wo eine zeitnahe medizinische Versorgung nötig ist, können Sie sich an die Kassenärztliche Vereinigung  unter 116117 wenden <pre/>
       <pre/>
      Bei lebensbedrohlichen Fällen wenden Sie sich an den Rettungsdienst unter 112. <pre/>
      Ab Montag, den 21.09.2026 sind wir wieder zu unseren regulären Öffnungszeiten für Sie da.<pre />
        Ihr URO-Praxisteam<pre /><pre />
      </p><pre/><pre/> 
      <img width={300} src={chat} alt="Anzeige" />
      <p>
        Sehr geehrte Patienten <pre/>‚
        <pre/>
        Wir sind eine Facharztpraxis, da kann es schon durchaus zu etwas längeren
        Wartezeiten kommen. Dafür bitte wir um Verständnis.<pre/>
        <pre/>
        Die Untersuchung bei Neupatienten ist immer etwas aufwändiger. Bitte planen
        Sie genügend Zeit ein.<pre/>
        <pre/>
        Wir haben mehrere Untersuchungs-/Behandlungsräume, deswegen kann es
        auch durchaus sein, dass ein Patient, der nach Ihnen kam, vor Ihnen aufgerufen
        wird.<pre/>
        <pre/>
        Viele Patienten kommen z.B. nur zur Blutabnahme, Katheterwechsel usw. und
        müssen an diesem Tag nicht zum Arzt.<pre/>
        Das sind Untersuchungen, die von den Fachangestellten durchgeführt
        werden.<pre/>
        <pre/>
        An manchen Tagen haben wir auch Notfälle. Dies sind Patienten mit z.B.
        Koliken und unter Schmerzen können diese Patienten nicht warten und
        brauchen zeitnah eine Versorgung.<pre/>
        <pre/>
        Wir bitten um Ihr Verständnis<pre/>
        Ihr URO-Praxisteam<pre /><pre />
      </p>
    </div>
  );
};

export default Anzeige;
